import { useDispatch as useReduxDispatch } from 'react-redux';

import type { AppDispatch } from '../store';

export const useDispatch = <T = AppDispatch>() => useReduxDispatch<T>();
